module.exports = __webpack_public_path__ + "static/media/wallet-icon.2ee21dca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/promocode/wallet-icon.svg
// module id = 1632
// module chunks = 103